@if (showArrowLeft | async) {
  <button
    class="scroll-container__arrow--left"
    mat-icon-button
    color="primary"
    (click)="scrollBar('left')">
    <mat-icon>keyboard_arrow_left</mat-icon>
  </button>
}

<div
  #scroll_container
  class="scroll-container d-flex align-items-center">
  @for (filterChipData of chips(); track filterChipData.id) {
    @if (filterChipData.active) {
      <button
        class="mr-2"
        mat-flat-button
        color="primary"
        (click)="onClickChip(filterChipData)">
        <ng-container *ngTemplateOutlet="chipContent"></ng-container>
      </button>
    } @else {
      <button
        class="mr-2"
        mat-stroked-button
        [disabled]="filterChipData.disabled"
        (click)="onClickChip(filterChipData)">
        <ng-container *ngTemplateOutlet="chipContent"></ng-container>
      </button>
    }

    <ng-template #chipContent>
      @if (filterChipData.icon) {
        <div class="icon-container d-flex align-items-center justify-content-center">
          <img
            class="icon-container__icon {{ filterChipData.active ? 'selected' : '' }}"
            [src]="iconsBaseUrl() + '/' + filterChipData.icon"
            (error)="changeToTitle(filterChipData)" />
        </div>
      } @else if (filterChipData.title) {
        <span
          class="label"
          [ngClass]="filterChipData.type"
          [class.selected]="filterChipData.active">
          {{ filterChipData.title }}
        </span>
      }
    </ng-template>
  }

  @if (showArrowRight | async) {
    <button
      class="scroll-container__arrow--right"
      mat-icon-button
      color="primary"
      (click)="scrollBar('right')">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  }
</div>
